import dynamic from 'next/dynamic';
import { useState } from 'react';
import MetaTags from '@otovo/shared/components/Sanity/MetaTags';
import getTitleFromSanityCampaignPage from '@otovo/shared/components/Sanity/getTitleFromSanityPage';
import { Sanity$ProductPage } from '@otovo/shared/types/sanityTypes';
import NextHead from 'next/head';
import ContentRowList from '../SanityLandingPage/ContentRowList';
import { getProductSEOsnippets } from '../../lib/sanity/getProductSEOsnippets';
import ProductHeroSection from './ProductHeroSection/ProductHeroSection';

const LandingPageNotification = dynamic(
  () => import('../LandingPageNotification/LandingPageNotification'),
);
const SanityBanner = dynamic(
  () => import('../LandingPageNotification/SanityBanner'),
);

type Props = {
  page: Sanity$ProductPage;
};

const ProductLandingPage = ({ page }: Props) => {
  const [showBanner, setShowBanner] = useState(!!page.banner?.content);

  const { productSEOData } = page;

  return (
    <>
      <LandingPageNotification>
        {page.banner?.content && (
          <SanityBanner
            banner={page.banner}
            onDismiss={() => setShowBanner(false)}
          />
        )}
      </LandingPageNotification>
      <MetaTags
        meta={page.meta}
        defaultTags={{
          title: getTitleFromSanityCampaignPage(page),
          description: page.lead || '',
          image: page.mainImage,
        }}
      />

      <NextHead>
        {productSEOData && (
          <script
            key={productSEOData._id}
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: getProductSEOsnippets(productSEOData),
            }}
          />
        )}
      </NextHead>

      <ProductHeroSection page={page} isBannerShown={showBanner} />
      <div id="content-row">
        <ContentRowList
          rows={page.rows}
          rowContext={{ mainHardwareType: page.mainHardwareType }}
        />
      </div>
    </>
  );
};

export default ProductLandingPage;
